import request from './request';
import {ISensorStatus} from 'model/status';

export const getSensorStatusByID = (id: number) =>
  request.request<ISensorStatus>({
    url: `/sensors/${id}/status`,
    method: 'GET',
  });
